module.exports = __webpack_public_path__ + "img/cancel.65265961.svg";